import api from '../api';

const MENU_LIST = api.events.menuList.actionSuccess;

const defaultState = { list: [] };

export default (state = defaultState, action) => {
  switch (action.type) {
    case MENU_LIST:
      return { ...state, list: action.data };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/menus.js